import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hasUrlParameter } from "../../../shared/global-tools/url-parameters";
import { AproposSection } from "../sections/AproposSection";
import { FonctionaliteSection } from "../sections/FonctionaliteSection";
import { FooterSection } from "../sections/FooterSection";
import { PerformanceSection } from "../sections/PerformanceSection/performanceSection";
import { Header } from "../sections/headerSection";
import "./LandingPageScreen.scss";

export default function LandingPageScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    if (hasUrlParameter("token")) {
      const queryParams = window.location.search;
      navigate(`/app${queryParams}`);
    }
  }, []);

  return (
    <>
      <Header />
      <main className="LandingPageScreen-main">
        <AproposSection />
        <PerformanceSection />
        <FonctionaliteSection />
        <FooterSection />
      </main>
    </>
  );
}
